var _radialGradient, _path, _linearGradient, _path2, _path3, _linearGradient2, _path4, _linearGradient3, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "512px",
    height: "512px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "LjJbayjp7KZ42w6NbB71pa",
    cx: 32.375,
    cy: 500.431,
    r: 49.78,
    gradientTransform: "matrix(1 0 0 -1 0 536)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#f8eecd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#fdf4dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6e1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LjJbayjp7KZ42w6NbB71pa)",
    d: "M60,44H45l-2.6-1h6.012c1.138,0,2.202-0.721,2.497-1.821C51.355,39.516,50.096,38,48.5,38 c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5h2.912c1.139,0,2.202-0.721,2.497-1.821C54.355,31.516,53.096,29,51.5,29H51 c-1.105,0-2-0.895-2-2s0.895-2,2-2h9.412c1.139,0,2.202-0.721,2.497-1.821C63.355,21.516,62.096,20,60.5,20H59c-1.105,0-2-0.895-2-2 s0.895-2,2-2h2c1.848,0,3.319-1.693,2.94-3.605C63.657,10.972,62.32,10,60.869,10H50.5C49.672,10,49,9.328,49,8.5S49.672,7,50.5,7 h5.912c1.139,0,2.202-0.721,2.497-1.821C59.355,3.516,58.096,2,56.5,2H10.588C9.449,2,8.386,2.721,8.091,3.821 C7.645,5.484,8.904,7,10.5,7l0,0C11.881,7,13,8.119,13,9.5S11.881,12,10.5,12H9.588H7c-1.65,0-3,1.35-3,3s1.35,3,3,3h19 c0.352,0,0.685-0.073,1-0.185V29h-7.412c-1.139,0-2.202,1.721-2.497,2.821c-0.219,0.817-0.024,1.595,0.418,2.179H3.5 C2.119,34,1,35.119,1,36.5S2.119,39,3.5,39h1C5.881,39,7,40.119,7,41.5S5.881,44,4.5,44H4c-1.657,0-3,1.343-3,3s1.343,3,3,3h5.5 c1.381,0,2.5,1.119,2.5,2.5S10.881,55,9.5,55H8c-1.657,0-3,1.343-3,3s1.343,3,3,3h48c1.657,0,3-1.343,3-3s-1.343-3-3-3h-0.5 c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5H60c1.657,0,3-1.343,3-3S61.657,44,60,44z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LjJbayjp7KZ42w6NbB71pb",
    x1: 32,
    x2: 32,
    y1: -16.261,
    y2: 62.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00eddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#00e6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#00bbd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b2cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b2cf"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LjJbayjp7KZ42w6NbB71pb)",
    d: "M57,31c0,13.805-11.195,25-25,25S7,44.805,7,31S18.195,6,32,6S57,17.195,57,31z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M38.493,34.702c-1.044,1.144-2.509,1.723-3.195,1.723 c-0.794,0-1.227-0.486-1.316-1.217c-0.03-0.28-0.02-0.563,0.03-0.841c0.262-1.638,0.865-2.655,0.827-2.965 c-0.011-0.089-0.061-0.133-0.126-0.133c-0.507,0-2.288,1.837-2.558,3.054l-0.21,0.974c-0.138,0.686-0.81,1.128-1.273,1.128 c-0.221,0-0.389-0.11-0.418-0.354c-0.009-0.111,0-0.223,0.026-0.332l0.099-0.513c-0.96,0.718-1.995,1.202-2.48,1.202 c-0.662,0-1.034-0.354-1.166-0.886c-0.437,0.576-1.016,0.886-1.633,0.886c-0.787,0-1.546-0.521-1.91-1.292 c-0.519,0.583-1.134,1.153-1.87,1.624C20.234,37.447,19.025,38,17.593,38c-1.322,0-2.445-0.708-3.066-1.283 c-0.921-0.863-1.408-2.147-1.551-3.32c-0.452-3.696,1.798-8.542,5.284-10.666c0.8-0.487,1.696-0.73,2.51-0.73 c1.675,0,2.925,1.198,3.1,2.63c0.158,1.29-0.358,2.405-1.789,3.126c-0.73,0.37-1.092,0.352-1.206,0.176 c-0.076-0.118-0.033-0.317,0.114-0.439c1.345-1.124,1.37-2.046,1.212-3.346c-0.102-0.836-0.653-1.372-1.27-1.372 c-2.644,0-6.436,5.931-5.909,10.246c0.206,1.682,1.237,3.63,3.352,3.63c0.705,0,1.452-0.199,2.117-0.531 c1.16-0.593,1.816-1.062,2.475-1.83c-0.162-1.995,1.55-4.5,4.098-4.5c1.102,0,2.015,0.442,2.123,1.328 c0.135,1.106-0.807,1.328-1.16,1.328c-0.309,0-0.804-0.089-0.839-0.376c-0.038-0.31,0.667-0.133,0.58-0.841 c-0.054-0.442-0.514-0.597-0.954-0.597c-1.586,0-2.462,2.213-2.294,3.586c0.076,0.62,0.394,1.239,0.967,1.239 c0.462,0,1.13-0.664,1.386-1.638c0.162-0.664,0.79-1.106,1.254-1.106c0.242,0,0.41,0.11,0.44,0.354 c0.01,0.089,0.002,0.2-0.026,0.332c-0.053,0.287-0.274,1.245-0.263,1.443c0.008,0.173,0.107,0.41,0.407,0.41 c0.238,0,1.112-0.472,1.922-1.198c0.254-1.314,0.568-2.939,0.593-3.067c0.099-0.533,0.29-1.081,1.37-1.081 c0.221,0,0.389,0.11,0.421,0.376c0.01,0.088,0.002,0.2-0.026,0.332l-0.302,1.366c0.947-1.262,2.42-2.19,3.302-2.19 c0.375,0,0.664,0.198,0.713,0.597c0.027,0.222-0.038,0.598-0.184,1.018c-0.314,0.862-0.666,2.159-0.9,3.275 c-0.05,0.237,0.033,0.595,0.466,0.595c0.346,0,1.458-0.424,2.356-1.61c-0.006-0.168-0.009-0.338-0.009-0.51 c0-0.93,0.066-1.682,0.242-2.234c0.176-0.576,0.904-1.128,1.388-1.128c0.243,0,0.419,0.133,0.419,0.398 c0,0.089-0.022,0.2-0.066,0.31c-0.33,0.974-0.506,1.882-0.506,2.789c0,0.509,0.11,1.328,0.221,1.748 c0.022,0.089,0.043,0.177,0.131,0.177c0.154,0,1.19-1.018,1.939-2.258c-0.662-0.421-1.036-1.195-1.036-2.147 c0-1.593,0.948-2.412,1.873-2.412c0.727,0,1.388,0.531,1.388,1.593c0,0.665-0.265,1.417-0.638,2.147c0,0,0.154,0.022,0.22,0.022 c0.573,0,1.014-0.266,1.257-0.554c0.11-0.125,0.212-0.223,0.31-0.28c0.738-0.891,1.819-1.535,3.088-1.535 c1.08,0,2.012,0.421,2.12,1.306c0.138,1.128-0.826,1.35-1.157,1.35c-0.33,0-0.826-0.089-0.861-0.376 c-0.035-0.287,0.689-0.133,0.605-0.818c-0.054-0.443-0.516-0.62-0.957-0.62c-1.477,0-2.492,1.97-2.297,3.563 c0.078,0.642,0.374,1.262,0.947,1.262c0.462,0,1.154-0.665,1.409-1.638c0.164-0.642,0.79-1.106,1.253-1.106 c0.22,0,0.41,0.11,0.442,0.376c0.016,0.133-0.037,0.421-0.284,1.46c-0.101,0.442-0.121,0.819-0.083,1.129 c0.079,0.642,0.373,1.062,0.645,1.306c0.099,0.088,0.157,0.198,0.165,0.266c0.021,0.177-0.114,0.332-0.334,0.332 c-0.066,0-0.154,0-0.226-0.044c-1.135-0.465-1.606-1.239-1.739-1.97c-0.438,0.553-1.018,0.862-1.613,0.862 c-1.014,0-2.004-0.886-2.144-2.036c-0.058-0.473-0.001-0.981,0.154-1.48c-0.411,0.254-0.854,0.395-1.251,0.395 c-0.133,0-0.242,0-0.374-0.022c-0.991,1.438-2.027,2.434-2.821,2.877c-0.33,0.177-0.638,0.266-0.859,0.266 c-0.177,0-0.375-0.044-0.462-0.199C38.709,35.888,38.572,35.342,38.493,34.702L38.493,34.702z M42.084,29.989 c0,0.62,0.308,1.262,0.705,1.682c0.155-0.421,0.243-0.841,0.243-1.262c0-0.797-0.309-1.151-0.551-1.151 C42.194,29.258,42.084,29.657,42.084,29.989z",
    clipRule: "evenodd"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LjJbayjp7KZ42w6NbB71pc",
    x1: 41.176,
    x2: 41.176,
    y1: 16.087,
    y2: 48.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00eddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#00e6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#00bbd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b2cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b2cf"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LjJbayjp7KZ42w6NbB71pc)",
    d: "M53.35,43.995c-1.333,2.192-2.981,4.118-4.89,5.79c-0.88,0.77-1.81,1.49-2.8,2.13 c-2.268,1.502-4.789,2.602-7.42,3.29c-2.461,0.619-5.068,0.915-7.64,0.75c-1.04-0.22-1.8-1.24-1.55-2.4c0.2-0.94,1.1-1.56,2.06-1.56 h6.39c0.83,0,1.5-0.67,1.5-1.5s-0.67-1.5-1.5-1.5c-0.216,0-1,0.003-2,0.003s-2.5-1-2.5-2.503c0-1.497,1.5-2.497,2.5-2.497 c0.5,0,1.705-0.003,2-0.003H53.35z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "LjJbayjp7KZ42w6NbB71pd",
    x1: 21.293,
    x2: 21.293,
    y1: 8,
    y2: 41.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00eddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#00e6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#00bbd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b2cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00b2cf"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#LjJbayjp7KZ42w6NbB71pd)",
    d: "M32.52,6.007c-0.17-0.01-0.35-0.01-0.52-0.01c-9.834,0-18.346,5.722-22.42,14.003h4.894 c0.009,0,0.017-0.003,0.026-0.003h12.14c1.3,0,2.36-1.12,2.36-2.5s-1.06-2.5-2.36-2.5h-1.98c-1.46,0-2.74-1.2-2.66-2.65 c0.04-0.63,0.31-1.2,0.73-1.62c0.45-0.45,1.08-0.73,1.77-0.73h5.86c1.26,0,2.43-0.87,2.62-2.12C33.08,7.177,32.89,6.517,32.52,6.007 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanva);
export default __webpack_public_path__ + "static/media/canva.a7f94232d3c98473104b121951f4dab2.svg";
export { ForwardRef as ReactComponent };